import { render, staticRenderFns } from "./StudyAddEdit.vue?vue&type=template&id=3d168d89"
import script from "./StudyAddEdit.vue?vue&type=script&lang=js"
export * from "./StudyAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports